import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section id="categories" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-4">
            Explore Product Categories
          </h2>
          <p className="text-foreground-600 max-w-2xl mx-auto text-sm md:text-base">
            Browse our curated Sugargoo Spreadsheet categories and discover trending products across every style — from sneakers to luxury accessories.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4">
          {categories.map((cat) => (
            <a
              key={cat.seq}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group relative bg-background-100 rounded-xl overflow-hidden transition-all duration-300 hover:ring-2 hover:ring-primary-300 cursor-pointer"
            >
              <div className="aspect-[4/3] w-full overflow-hidden">
                <img
                  src={cat.image}
                  alt={`${cat.name} products on Sugargoo Spreadsheet`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-4 flex items-center justify-between">
                <span className="text-sm font-semibold text-foreground-800 group-hover:text-primary-600 transition-colors duration-300">
                  {cat.name}
                </span>
                <div className="w-5 h-5 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <i className="ri-arrow-right-up-line text-primary-500 text-sm"></i>
                </div>
              </div>
            </a>
          ))}
        </div>

        <div className="text-center mt-10">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-8 py-3 rounded-lg bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            View All Products on Main Site
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-up-line"></i>
            </div>
          </a>
        </div>
      </div>
    </section>
  );
}